import { Box, Card, CardContent, CardHeader, Divider, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ZSHIP_ID } from "src/constants";
export default function OrderInfoCard({ order }) {
    const { t } = useTranslation()
    const profile = useSelector(state => state.entities.profile.profile)
    return (
        <Card>
            <CardHeader title={t("Order's Info")} />
            <Divider />
            <CardContent>
                <Grid container spacing={1}>
                    {!!order?.deliveryDate && <Grid item xs={12}>
                        <Box display="flex" alignItems="center">
                            <Typography color="text.light" sx={{ mr: 2 }}>{t("This order is scheduled")} : </Typography>
                            <Typography variant="subtitle1" fontWeight="bold">{moment(order?.deliveryDate).format("dddd DD/MM/YY")}</Typography>
                        </Box>
                    </Grid>}
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                        <Box display="flex" alignItems="center">
                            <Typography color="text.light" sx={{ mr: 2 }}>{t("Order reference number")} : </Typography>
                            {
                                profile?.merchant?.shippingType === "LAST_MILE" ?
                                    <Typography variant="subtitle1" fontWeight="bold">{order?.barCode[0]?.text ?? '-'}</Typography>
                                    :
                                    <Typography variant="subtitle1" fontWeight="bold">{order?.merchantOrderNumber ?? '-'}</Typography>
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Box display="flex" alignItems="center">
                            <Typography color="text.light" sx={{ mr: 2 }}>{t("Package Count")} : </Typography>
                            <Typography variant="subtitle1" fontWeight="bold">{order?.packagesCount}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Box display="flex" alignItems="center">
                            <Typography color="text.light" sx={{ mr: 2 }}>{t("Weight")} : </Typography>
                            <Typography variant="subtitle1" fontWeight="bold">{order?.weight}</Typography>
                            <Typography fontWeight="bold" sx={{ ml: 1 }}>{t("KG")}</Typography>
                        </Box>
                    </Grid>
                    {
                        ZSHIP_ID.includes(profile?.merchant?.id) &&
                        <>
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Box display="flex" alignItems="center">
                                    <Typography color="text.light" sx={{ mr: 2 }}>{t("Net Weight")} : </Typography>
                                    <Typography variant="subtitle1" fontWeight="bold">{order?.netDimWeight}</Typography>
                                    <Typography fontWeight="bold" sx={{ ml: 1 }}>{t("KG")}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Box display="flex" alignItems="center">
                                    <Typography color="text.light" sx={{ mr: 2 }}>{t("Height")} : </Typography>
                                    <Typography variant="subtitle1" fontWeight="bold">{order?.height}</Typography>
                                    <Typography fontWeight="bold" sx={{ ml: 1 }}>{t("CM")}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Box display="flex" alignItems="center">
                                    <Typography color="text.light" sx={{ mr: 2 }}>{t("Width")} : </Typography>
                                    <Typography variant="subtitle1" fontWeight="bold">{order?.width}</Typography>
                                    <Typography fontWeight="bold" sx={{ ml: 1 }}>{t("CM")}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Box display="flex" alignItems="center">
                                    <Typography color="text.light" sx={{ mr: 2 }}>{t("Length")} : </Typography>
                                    <Typography variant="subtitle1" fontWeight="bold">{order?.length}</Typography>
                                    <Typography fontWeight="bold" sx={{ ml: 1 }}>{t("CM")}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Box display="flex" alignItems="center">
                                    <Typography color="text.light" sx={{ mr: 2 }}>{t("Volume")} : </Typography>
                                    <Typography variant="subtitle1" fontWeight="bold">{order?.volume}</Typography>
                                    <Typography fontWeight="bold" sx={{ ml: 1 }}>{t("CM3")}</Typography>
                                </Box>
                            </Grid>
                        </>
                    }
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Box display="flex" alignItems="center">
                        <Typography color="text.light" sx={{ mr: 2 }}>{t("COD (Cash On Delivery)")} : </Typography>
                        <Typography variant="subtitle1" fontWeight="bold">{t("MoneyAmount", { amount: order?.amountPayable })}</Typography>
                    </Box>
                </Grid>
            </CardContent>
        </Card>
    )
}